import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { mostraAlerta } from "../../componentes/alerts/sweetAlert";
import { AxiosPublico } from "../../componentes/axios/Axios";
import { UsuarioEnviarPin } from "../../configuracion/apiUrls";
import { NegocioConfig } from "../../configuracion/Empresa";

const EnviarPin = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (email.trim() === "") {
        mostraAlerta("Complete los campos", "warning");
        return;
      }
      const response = await AxiosPublico.post(UsuarioEnviarPin, {
        correo: email.trim(),
      });
      if (response.data && response.data.correo) {
        mostraAlerta(
          "Se ha enviado un pin a su correo " + response.data.correo,
          "success"
        );
        setTimeout(
          () =>
            navigate("/actualizar-contrasena", {
              state: { correo: response.data.correo },
            }),
          2000
        );
      } else {
        mostraAlerta("Se ha enviado un pin a su correo", "success");
        setTimeout(
          () =>
            navigate("/actualizar-contrasena", {
              state: { correo: email.trim() },
            }),
          2000
        );
      }
    } catch (error) {
      console.log("Error:", error);
      if (error.response) {
        console.log("Error Response Data:", error.response.data);
        if (Array.isArray(error.response.data)) {
          error.response.data.forEach((f) => {
            mostraAlerta("Campo: " + f.path + ". " + f.msg, "warning");
          });
        } else if (error.response.data.error) {
          mostraAlerta(error.response.data.error, "warning");
        } else {
          mostraAlerta("Error al enviar el PIN", "error");
        }
      } else {
        mostraAlerta("Error de red o servidor no disponible", "error");
      }
    }
  };

  return (
    <div className="hold-transition login-page d-flex align-items-center" style={{ minHeight: "100vh" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-lg border-0 rounded-lg mt-5">
              <div className="card-body p-0">
                <div className="row no-gutters">
                  {/* Contenedor del Logo - Visible en pantallas grandes */}
                  <div className="col-lg-6 d-none d-lg-flex flex-column align-items-center justify-content-center p-5 bg-primary text-white">
                    <div className="login-logo text-center">
                      <img
                        src={NegocioConfig.imagen}
                        alt="SIGVES LOGO"
                        className="img-fluid rounded-circle"
                        style={{ width: "250px", height: "250px", marginBottom: "2rem" }}
                      />
                      <h1 className="h3 font-weight-bold">Recuperar Contraseña</h1>
                      <p className="lead">Introduce tu correo electrónico para recibir un PIN de seguridad.</p>
                    </div>
                  </div>
                  {/* Formulario de Recuperación de PIN */}
                  <div className="col-lg-6">
                    <div className="p-5">
                      <div className="text-center mb-4 d-lg-none">
                        <img
                          src={NegocioConfig.imagen}
                          alt="SIGVES LOGO"
                          className="img-fluid rounded-circle mb-3"
                          style={{ width: "150px", height: "150px" }}
                        />
                      </div>
                      <p className="login-box-msg h4 text-center">Recuperar PIN</p>
                      <form onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                          <div className="input-group">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Correo electrónico"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              autoComplete="email"
                            />
                            <div className="input-group-append">
                              <div className="input-group-text">
                                <span className="fas fa-envelope"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-grid gap-2 mt-4">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block btn-lg"
                          >
                            Enviar PIN
                          </button>
                        </div>
                      </form>
                      <div className="text-center mt-3">
                        <Link to="/login" className="forgot-password text-primary">
                          Volver al inicio de sesión
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnviarPin;
